import {
  mapNotificationDetail,
  mapNotificationPage,
} from './mapNotification';
import NotificationsApi from './repository';

export function fetchNotificationPage({
  page = 0,
  category = '',
  search = '',
} = {}) {
  return NotificationsApi.getNotifications({ page, category, search })
    .then(mapNotificationPage);
}

export function fetchNotificationDetail(id) {
  return NotificationsApi.getNotification(id).then(mapNotificationDetail);
}
